module.exports = __webpack_public_path__ + "static/media/04d.542c94b8.png";